import * as e from 'react';
import { forwardRef, memo } from 'react';

var i=({title:r,titleId:o,...t},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":o,...t},r?e.createElement("title",{id:o},r):null,e.createElement("path",{d:"M13 3.65 12.35 3 8 7.34 3.65 3 3 3.65 7.34 8 3 12.35l.65.65L8 8.66 12.35 13l.65-.65L8.66 8Z"})),n=forwardRef(i),a=memo(n),G=a;

export { G as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-RAQE67KC.mjs.map